import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const Container = styled.div`
  padding: 0 15px;
  background-color: ${COLORS.LIGHT_GREY};
  margin-bottom: 20px;
`;
const Img = styled.img`
  border-right: 2px solid #a3a3a3;
  max-height: 29px;
  max-width: 215px;
  padding: 0 15px;
  &:last-child {
    border-right: 0;
  }
`;
const Section = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;
export { Container, Img, Section };
